const API_Config = {

    http_url        : 'https://mordorintelligence.com:81/api',
    https_url       : '',
    end_point       : {
                            custome_report              :   '/leads/customization',
                            subscribeNewsLetter         :   '/leads/subscribeNewsLetter',
                            contactUs                   :   '/leads/contactUs',
                            category                    :   '/categories',
                            rpt_desc                    :   '/reports/',
                            reports                     :   '/reports/'
                      }


};

export default API_Config;


// WEBPACK FOOTER //
// ./src/API_Config.js